module.exports = __webpack_public_path__ + "static/parade-2020-house23-7351343ee1ddb7d2cf15e4207e4165c3.jpg";